<template>
	<div class="sub_contents">
		<div class="cont_center">
			<h1 class="title_page">제휴문의</h1>
		</div>

		<div class="cont_center">
			<div class="input_area">
				<div>
					<h3 class="title_input">제목</h3>
					<InputText v-model="form.qnaTitle" :placeholder="placeholderTitle" />
				</div>
			</div>

			<div class="input_area col_2">
				<div>
					<h3 class="title_input">기업명</h3>
					<InputText v-model="form.partnerName" :placeholder="placeholderPartnerName" />
				</div>

				<div>
					<h3 class="title_input">담당자명</h3>
					<InputText v-model="form.name" :placeholder="placeholderWriter" />
				</div>
			</div>

			<div class="input_area col_2">
				<div>
					<h3 class="title_input">연락처 <span>(담당자)</span></h3>
					<InputText v-model="form.phone" :placeholder="placeholderPhone" @input="validatePhoneInput" />
					<p v-if="phoneError" class="error-message">
						휴대폰 번호는 숫자만 입력 가능하며, 10~11자리여야 합니다.
					</p>
				</div>

				<div>
					<h3 class="title_input">이메일 <span>(담당자)</span></h3>
					<div class="email_area">
						<InputText v-model="emailId" @input="validateEmail" /> @
						<InputText v-model="emailDomain" @input="validateEmail" />
						<SelectBox :optionName="selectmail" :items="emailList" dropdownId="emailList"
							@itemSelected="handleEmailDomainSelected" />
					</div>
					<p v-if="emailError" class="error-message">
						유효한 이메일 주소를 입력해 주세요.
					</p>
				</div>
			</div>

			<div class="input_area">
				<div>
					<h3 class="title_input">문의 내용</h3>
					<TextArea v-model="form.qnaRmks" :placeholder="placeholdertextarea"></TextArea>
				</div>

				<div>
					<FileUpload ref="fileUpload" @file-uploaded="handleFileUploaded"
						@upload-error="handleFileUploadError" @upload-progress="handleFileUploadProgress"
						@file-removed="handleFileRemoved" />
					<p v-if="fileUploadError" class="error-message">
						파일 업로드 중 오류가 발생했습니다.
					</p>
					<p v-if="uploadedFile" class="success-message">
						파일이 업로드 되었습니다: {{ uploadedFile.name }}
					</p>
				</div>
			</div>

			<div class="agree_box">
				<ol class="agree_info_list">
					<li>
						<span>01</span> <strong>수집/이용목적 :</strong> 제휴문의에 따른
						본인확인 및 의사소통 경로 확보
					</li>
					<li>
						<span>02</span> <strong>수집/이용항목 :</strong> 회사명(담당자명),
						메일주소, 전화번호
					</li>
					<li>
						<span>03</span>
						<strong>개인정보 보유 및 이용기간 :</strong> 개인정보 수집 및 이용에
						대한 목적이 달성된 후 해당 정보를 지체 없이 파기
					</li>
				</ol>

				<p class="agree_info_txt">
					※ 그 밖의 사항은 개인정보 처리방침을 준수합니다.
				</p>

				<div class="personal_agree_area">
					<CheckBox v-for="option in checkOptions" :key="option.value" :id="option.value"
						:value="option.value" :label="option.label" v-model="selectedOptions" />
				</div>
			</div>

			<div class="btn_write_area">
				<button type="button" class="btn_type2 inquiry" @click="handleSubmitInquiry">
					<span>?</span>
					문의하기
				</button>
			</div>
		</div>
	</div>

	<AlertPopup v-model="alertRequiredShow" title="알림">
		<template #layer_content>
			<p class="alert_txt">
				모든 항목은 필수 항목입니다.<br />
				빠짐없이 기입해 주세요.
			</p>
		</template>
	</AlertPopup>

	<AlertPopup v-model="alertSuccessShow" title="알림">
		<template #layer_content>
			<p class="alert_txt">문의가 성공적으로 제출되었습니다.</p>
			<div class="btn_layer_area">
				<button type="button" class="btn_type1 small" @click="alertSuccessShow = false">확인</button>
			</div>
		</template>
	</AlertPopup>

	<AlertPopup v-model="confirmSubmitShow" title="확인" :customClass="dynamicClass">
		<template #layer_content>
			<p class="alert_txt">
				입력하신 내용으로<br />
				저장하시겠습니까?
			</p>

			<div class="btn_layer_area">
				<button type="button" class="btn_type1 small" @click="handleConfirm">
					확인
				</button>
			</div>
		</template>
	</AlertPopup>
</template>

<script>
import CheckBox from "@/components/CheckBox";
import InputText from "@/components/InputText";
import SelectBox from "@/components/SelectBox";
import TextArea from "@/components/TextArea";
import { postAxios } from "@/lib/AxiosCall";
import AlertPopup from "@/components/AlertPopup.vue";
import FileUpload from "@/components/FileUpload.vue";
import { encryptAES256 } from '@/lib/crypto'; // 암호화 함수 import 추가
import { LOCAL_STORAGE_HVM_USERINFO } from "@/lib/Constant";

export default {
	components: {
		CheckBox,
		InputText,
		SelectBox,
		TextArea,
		AlertPopup,
		FileUpload,
	},
	data() {
		return {
			placeholderTitle: "제목을 입력하세요.",
			placeholderCompany: "기업명을 입력하세요.",
			placeholderWriter: "담당자명을 입력하세요.",
			placeholderPhone: "연락처를 입력하세요.(숫자만 입력)",
			placeholdertextarea: "제휴 문의 내용을 입력하세요.",
			selectmail: "직접 입력",
			emailList: [
				{
					name: "네이버",
					value: "naver.com",
				},
				{
					name: "다음",
					value: "daum.net",
				},
				{
					name: "지메일",
					value: "gmail.com",
				},
				{
					name: "직접 입력",
					value: "",
				},
			],
			checkOptions: [
				{
					label: "개인정보수집 및 이용 동의",
					value: "1",
				},
			],
			form: {
				qnaTitle: "",
				partnerName: "",
				name: "",
				phone: "",
				email: "",
				qnaRmks: "",
				fileUuid: "",
			},
			emailId: "",
			emailDomain: "",
			selectedOptions: [],
			alertRequiredShow: false,
			alertSuccessShow: false,
			confirmSubmitShow: false,
			dynamicClass: "confirm",
			phoneError: false,
			emailError: false,
			uploadedFile: null,
			fileUploading: false,
			fileUploadError: false,
			alertContent: '', // 에러 메시지용 추가
		};
	},
	setup() { },
	methods: {
		handleSubmitInquiry() {
			console.log("selectedOptions:", this.selectedOptions);
			console.log("qnaTitle:", this.form.qnaTitle);
			console.log("partnerName:", this.form.partnerName);
			console.log("name:", this.form.name);
			console.log("phone:", this.form.phone);
			console.log("qnaRmks:", this.form.qnaRmks);
			console.log("emailId:", this.emailId);
			console.log("emailDomain:", this.emailDomain);
			console.log("fileUuid:", this.form.fileUuid);

			if (
				!this.selectedOptions.includes("1") ||
				!this.form.qnaTitle ||
				!this.form.partnerName ||
				!this.form.name ||
				!this.form.phone ||
				!this.form.qnaRmks ||
				!this.emailId ||
				!this.emailDomain
			) {
				this.alertRequiredShow = true;
				return;
			}

			if (this.fileUploading) {
				alert("파일 업로드가 완료될 때까지 기다려주세요.");
				return;
			}

			this.confirmSubmitShow = true;
		},
		resetForm() {
			this.form = {
				qnaTitle: "",
				partnerName: "",
				name: "",
				phone: "",
				email: "",
				qnaRmks: "",
				fileUuid: "",
			};

			this.selectedOptions = [];
			this.emailId = "";
			this.emailDomain = "";

			// 파일 업로드 관련 상태 초기화
			this.uploadedFile = null;
			this.fileUploading = false;
			this.fileUploadError = false;

			// 파일 업로드 컴포넌트 초기화 이벤트 발생
			this.$nextTick(() => {
				// 파일 업로드 컴포넌트에 대한 참조가 있는 경우 resetFileInput 호출
				if (this.$refs.fileUpload && typeof this.$refs.fileUpload.resetFileInput === 'function') {
					this.$refs.fileUpload.resetFileInput();
				}
			});
		},
		handleEmailDomainSelected(selectedValue) {
			console.log("Selected email domain:", selectedValue);
			this.emailDomain = selectedValue;
			this.validateEmail();
		},
		async handleConfirm() {
			this.confirmSubmitShow = false;

			if (this.phoneError || this.emailError) {
				return;
			}

			try {
				// 이메일과 연락처 암호화
				const fullEmail = `${this.emailId}@${this.emailDomain}`;
				const cleanPhone = this.form.phone.replace(/[^0-9]/g, ''); // 숫자만 추출

				const encryptedEmail = encryptAES256(fullEmail);
				const encryptedPhone = encryptAES256(cleanPhone);

				console.log('암호화 전:', {
					email: fullEmail,
					phone: cleanPhone
				});

				console.log('암호화 후:', {
					email: '암호화된 이메일',
					phone: '암호화된 연락처'
				});

				const loginInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO));

				// userId가 있을 때만 암호화, 없으면 빈 문자열 처리
				const encryptedId = loginInfo && loginInfo.userId ? encryptAES256(loginInfo.userId) : "";

				// API 전송용 데이터 준비
				const requestData = {
					...this.form,
					userId: encryptedId,
					email: encryptedEmail || fullEmail,
					phone: encryptedPhone || cleanPhone,
				};

				// form.phone도 암호화된 값으로 업데이트
				requestData.phone = encryptedPhone || cleanPhone;

				console.log('전송할 데이터:', {
					...requestData,
					email: '암호화된 이메일',
					phone: '암호화된 연락처'
				});

				const response = await postAxios("/hvm/v1/help/partner/qna", requestData);

				console.log("문의 제출 성공:", response);
				this.alertSuccessShow = true;
				this.resetForm();
			} catch (error) {
				console.error("문의 제출 중 오류 발생:", error);

				// 에러 처리 - 사용자에게 알림
				this.alertContent = "문의 제출 중 오류가 발생했습니다. 다시 시도해주세요.";
				this.alertRequiredShow = true;
			}
		},

		// API 전송용 숫자만 추출하는 함수 추가
		getCleanPhoneNumber(phoneNumber) {
			if (!phoneNumber) return '';
			return phoneNumber.replace(/[^0-9]/g, '');
		},

		validatePhone(phone) {
			const phoneRegex = /^[0-9]{10,11}$/;
			return phoneRegex.test(phone);
		},
		validatePhoneInput() {
			this.phoneError = !this.validatePhone(this.form.phone);
		},
		validateEmail() {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			this.emailError = !emailRegex.test(`${this.emailId}@${this.emailDomain}`);
			console.log(emailRegex.test(`${this.emailId}@${this.emailDomain}`));
		},
		handleFileUploaded(fileData) {
			console.log("파일 업로드 완료:", fileData);
			this.uploadedFile = fileData;
			this.form.fileUuid = fileData.uuid;
			this.fileUploadError = false;
		},
		handleFileUploadError(error) {
			console.error("파일 업로드 오류:", error);
			this.fileUploadError = true;
			this.uploadedFile = null;
			this.form.fileUuid = "";
		},
		handleFileUploadProgress(isUploading) {
			this.fileUploading = isUploading;
		},
		handleFileRemoved() {
			this.uploadedFile = null;
			this.form.fileUuid = "";
		},
	},
};
</script>
